import { CodeBlock, type CodeFile } from "@generalapplications/ui";

import type { CodeTab, RichCodeBlock } from "@/content/contentSchema";
import { highlightCode } from "@/app/features/content/functions/syntaxHighlight";

export type CodeViewerProps = {
  block: RichCodeBlock;
  showLineNumbers?: boolean;
};

/** An article's code block: its file or files, highlighted by Shiki, on the
 * library's code surface. */
export function CodeViewer({
  block,
  showLineNumbers = false,
}: CodeViewerProps) {
  const tabs: CodeTab[] =
    block.tabs && block.tabs.length > 0
      ? block.tabs
      : [
          {
            label: block.language ?? "Code",
            language: block.language ?? "text",
            code: block.code ?? "",
            filename: block.filename,
          },
        ];
  const [first, ...rest] = tabs.map((tab): CodeFile => ({
    label: tab.label,
    filename: tab.filename,
    code: tab.code,
    html: highlightCode(tab.code, tab.language),
  }));

  return first ? (
    <CodeBlock files={[first, ...rest]} lineNumbers={showLineNumbers} />
  ) : null;
}
